import { Box, Dialog, FormControl, FormControlLabel, IconButton, Radio, RadioGroup, useTheme } from "@mui/material"
import React, { useContext, useState } from "react"
import CommonTypo from "../../components/CommonTypo"
import { pxToRem } from "../../theme/typography"
import NewButton from "../../components/NewButton"
import BellIcon from "../../assets/images/icon/BellIcon"
import ModalCloseIconWhite from "../../assets/images/icon/modalCloseIconWhite"
import { UserTypeContext } from "../../context/userStatus"
import { userService } from "../../services/auth"
import moment from "moment"
import { SnackBarCompV2 } from "../../components/snackBar"
import { useNavigate } from "react-router-dom"
import useWidth from "../../utils/useWidth"
import AccountRestrictionTimeout from "../../components/AccountRestrictionTimeout"
import { setUserRestrictions } from "../../store/actions/userTypeAction"

const PaymentPlanInfo = ({
    visiblePaymentInfo,
    onClose,
    fixClosePopup = () => { },
    closeAndOpenRestriction = () => { },
    subscriptionPlanEnded = false,
    subscriptionPlanEndedBilling = false,
    paymentStatus = null,
}) => {
    const width = useWidth()
    const isMobile = width < 768
    console.log("paymentStatus", paymentStatus);
    const [showSnakbar, setShowSnakbar] = useState(false);
    const [snakbarMsg, setSnakbarMsg] = useState("");
    const [msgType, setMsgType] = useState("");
    const token = localStorage.getItem("userDetails")
    const [selectedPlan, setSelectedPlan] = useState(null)
    const { state: IUserTypeState, dispatch: userTypeDispatch } =
        useContext(UserTypeContext);
    const isDarkMode = useTheme().palette.mode === "dark" || IUserTypeState.isDarkMode
    console.log("IUserTypeState.planProducts", IUserTypeState.planProducts)
    const navigate = useNavigate()
    const closeWithRestrictions = () => {
        console.log("closing popuop");
        if (paymentStatus === PAYMENT_STATUS.FREE_COMPLETED_V3) {
            onClose()
            closeAndOpenRestriction()
        } else {
            userTypeDispatch(setUserRestrictions(true))
            onClose()
        }

    }
    const closeWithSelectedPlan = () => {
        if (!selectedPlan) {
            setShowSnakbar(true)
            setMsgType("error")
            setSnakbarMsg("Please select a plan")
            return
        }
        const foundPlan = IUserTypeState.planProducts.find(it => {
            return it.price.id === selectedPlan
        })
        if (foundPlan) {
            createCheckoutLink(foundPlan)
        }
    }
    const getBillingPorta = () => {
        userService.billingPortal(token).then(data => {
            window.open(data.data.url)
        }).catch(err => {
            console.log("err", err);

        })
    }
    const createCheckoutLink = (planInfo) => {
        userService.createCheckout({
            price: planInfo.price.id
        }, token).then(data => {
            console.log("data", data)
            if (data.data) {
                window.open(data.data.url)
            }
        }).catch(err => {
            console.log("err", err);

        })
    }
    const getImage = () => {
        switch (paymentStatus) {
            case PAYMENT_STATUS.ONBOARD:
                return "/paymentplanwelcome.png"
            case PAYMENT_STATUS.FREE_COMPLETED:
                return "/paymentplanend.png"
            case PAYMENT_STATUS.FREE_COMPLETED_V2:
                return "/paymentfailed.png"
            case PAYMENT_STATUS.SUBSCRIPTION_ENDED:
            case PAYMENT_STATUS.FREE_COMPLETED_V3:
                return "/subscriptionended.png"
            case PAYMENT_STATUS.PAYMENT_SUCCESS:
                return "/paymentsuccess.png"
            case PAYMENT_STATUS.PAYMENT_FAILED:
                return "/paymentfailed.png"
            default:
                return "/paymentplanwelcome.png"
        }
    }
    const getTitleContent = () => {
        switch (paymentStatus) {
            case PAYMENT_STATUS.FREE_COMPLETED:
                return <>
                    <Box display={"flex"} flexDirection={"column"} gap={"8px"} padding={"0px 32px"}>
                        <CommonTypo size={16} lineHeight={24} color="var(--color-text-secondary)" fontWeight={700}>🐻‍❄️ Frost:</CommonTypo>
                        <CommonTypo size={isMobile ? 18 : 24} lineHeight={isMobile ? 20 : 24} color="var(--color-text-primary)" fontWeight={isMobile ? 600 : 700}>Oh No, The Fridge is Locked! 🔒</CommonTypo>
                        <CommonTypo size={isMobile ? 12 : 16} lineHeight={isMobile ? 20 : 24} color="var(--color-text-secondary)" fontWeight={400} extraSx={{
                            letterSpacing: isMobile ? '0%' : "-1%"
                        }}>My precious ice cream stash... I mean, your premium features are now under lock and chain! And you know how grumpy this polar bear gets without his frozen treats...</CommonTypo>
                    </Box>
                </>
            case PAYMENT_STATUS.FREE_COMPLETED_V2:
                return <>
                    <Box display={"flex"} flexDirection={"column"} gap={"8px"} padding={"0px 32px"}>
                        <CommonTypo size={isMobile ? 18 : 24} lineHeight={isMobile ? 20 : 24} color="var(--color-text-primary)" fontWeight={isMobile ? 600 : 700}>Account restricted</CommonTypo>
                        <CommonTypo size={isMobile ? 12 : 16} lineHeight={isMobile ? 20 : 24} color="var(--color-text-secondary)" fontWeight={400} extraSx={{
                            letterSpacing: isMobile ? '0%' : "-1%"
                        }}>We are sorry to inform you that your account was restricted. From now on you won’t be able to track metrics and use other features. To protect your privacy and avoid holding data unnecessarily, we will delete all of your data in <CommonTypo size={isMobile ? 12 : 16} lineHeight={isMobile ? 20 : 24} color="var(--color-text-secondary)" fontWeight={700} extraSx={{
                            letterSpacing: isMobile ? '0%' : "-1%"
                        }}>7 days</CommonTypo> if you do not subscribe</CommonTypo>
                    </Box>
                </>
            case PAYMENT_STATUS.SUBSCRIPTION_ENDED:
            case PAYMENT_STATUS.FREE_COMPLETED_V3:
                return <>
                    <Box display={"flex"} flexDirection={"column"} gap={"8px"} padding={"0px 32px"}>
                        <CommonTypo size={isMobile ? 18 : 24} lineHeight={isMobile ? 20 : 24} color="var(--color-text-primary)" fontWeight={isMobile ? 600 : 700}>Wanna join the party?</CommonTypo>
                        <Box display={"flex"} flexDirection={"column"} gap={"0px"} padding={"0px"}>
                            <CommonTypo size={isMobile ? 12 : 16} lineHeight={isMobile ? 20 : 24} color="var(--color-text-secondary)" fontWeight={isMobile ? 400 : 500} extraSx={{
                                letterSpacing: "-1%",
                                fontStyle: "italic"
                            }}>*Frost speaks to the host*</CommonTypo>
                            <CommonTypo size={isMobile ? 12 : 16} lineHeight={isMobile ? 20 : 24} color="var(--color-text-secondary)" fontWeight={400} extraSx={{
                                letterSpacing: "-1%",
                            }}>“Boss, we've got a potential VIP wanting to join our data-driven party! Should I roll out the ice-blue carpet? 🐻‍❄️”</CommonTypo>
                        </Box>

                    </Box>
                </>
            case PAYMENT_STATUS.PAYMENT_SUCCESS:
                return <Box display={"flex"} flexDirection={"column"} gap={isMobile ? "8px" : "16px"} padding={"0px 32px"}>
                    <CommonTypo size={isMobile ? 18 : 24} lineHeight={isMobile ? 20 : 24} color="var(--color-text-primary)" fontWeight={isMobile ? 600 : 700}>Pass Received</CommonTypo>
                    <CommonTypo size={isMobile ? 12 : 16} lineHeight={isMobile ? 20 : 24} color="var(--color-text-secondary)" fontWeight={400} extraSx={{
                        letterSpacing: isMobile ? '0%' : "-1%",
                    }}>Welcome to our private data-driven party. Let’s track your progress and discover cool patterns in your daily adventures together.</CommonTypo>

                </Box>
            case PAYMENT_STATUS.PAYMENT_FAILED:
                return <Box display={"flex"} flexDirection={"column"} gap={isMobile ? "8px" : "16px"} padding={"0px 32px"}>
                    <CommonTypo size={isMobile ? 18 : 24} lineHeight={isMobile ? 20 : 24} color="var(--color-text-primary)" fontWeight={isMobile ? 600 : 700}>Oops... something went wrong</CommonTypo>
                    <CommonTypo size={isMobile ? 12 : 16} lineHeight={isMobile ? 20 : 24} color="var(--color-text-secondary)" fontWeight={400} extraSx={{
                        letterSpacing: isMobile ? '0%' : "-1%",
                    }}>We couldn’t validate your pass. Please try again</CommonTypo>
                </Box>
            default:
                return <>
                    <Box display={"flex"} flexDirection={"column"} gap={"8px"} padding={"0px 32px"}>
                        <CommonTypo size={16} lineHeight={24} color="var(--color-text-secondary)" fontWeight={700}>🐻‍❄️ Frost:</CommonTypo>
                        <CommonTypo size={isMobile ? 18 : 24} lineHeight={isMobile ? 20 : 24} color="var(--color-text-primary)" fontWeight={isMobile ? 600 : 700}>14 Days with Frost (me) for free</CommonTypo>
                        <CommonTypo size={isMobile ? 12 : 16} lineHeight={isMobile ? 20 : 24} color="var(--color-text-secondary)" fontWeight={400} extraSx={{
                            letterSpacing: isMobile ? '0%' : "-1%"
                        }}>Let's explore your personal growth journey like an arctic expedition! I'll help you track your progress and discover cool patterns in your daily adventures. </CommonTypo>
                    </Box>
                </>
        }
    }
    const getStepper = () => {
        if ([PAYMENT_STATUS.ONBOARD, PAYMENT_STATUS.FREE_COMPLETED, PAYMENT_STATUS.FREE_COMPLETED_V3].includes(paymentStatus)) {
            return <Box display={"flex"} flexDirection={"column"} gap={"8px"} padding={"0px 32px"} sx={{
                marginTop: isMobile ? [PAYMENT_STATUS.FREE_COMPLETED, PAYMENT_STATUS.FREE_COMPLETED_V3].includes(paymentStatus) ? "20px" : "0px" : "24px"
            }}>
                <Box display={"flex"} flexDirection={"column"} gap={isMobile ? "24px" : "48px"} padding={"0px"}>
                    <PlanStepInfo isMobile={isMobile} icon={<svg width={isMobile ? "16" : "24"} height={isMobile ? "16" : "25"} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_3_374)">
                            <path d="M19.5 7.625H9.375V5.75C9.375 5.05381 9.65156 4.38613 10.1438 3.89384C10.6361 3.40156 11.3038 3.125 12 3.125C13.2666 3.125 14.4047 4.02688 14.6475 5.22406C14.6769 5.36884 14.7346 5.50641 14.8172 5.62892C14.8998 5.75142 15.0057 5.85645 15.1289 5.93802C15.252 6.01959 15.3901 6.0761 15.5351 6.10432C15.6801 6.13254 15.8293 6.13192 15.9741 6.1025C16.1188 6.07308 16.2564 6.01542 16.3789 5.93283C16.5014 5.85024 16.6065 5.74433 16.688 5.62115C16.7696 5.49797 16.8261 5.35992 16.8543 5.2149C16.8825 5.06988 16.8819 4.92072 16.8525 4.77594C16.3941 2.51562 14.3531 0.875 12 0.875C10.7075 0.876489 9.46842 1.39058 8.5545 2.3045C7.64058 3.21842 7.12649 4.45753 7.125 5.75V7.625H4.5C4.00272 7.625 3.52581 7.82254 3.17417 8.17417C2.82254 8.52581 2.625 9.00272 2.625 9.5V20C2.625 20.4973 2.82254 20.9742 3.17417 21.3258C3.52581 21.6775 4.00272 21.875 4.5 21.875H19.5C19.9973 21.875 20.4742 21.6775 20.8258 21.3258C21.1775 20.9742 21.375 20.4973 21.375 20V9.5C21.375 9.00272 21.1775 8.52581 20.8258 8.17417C20.4742 7.82254 19.9973 7.625 19.5 7.625ZM19.125 19.625H4.875V9.875H19.125V19.625ZM10.5 14.75C10.5 14.4533 10.588 14.1633 10.7528 13.9166C10.9176 13.67 11.1519 13.4777 11.426 13.3642C11.7001 13.2506 12.0017 13.2209 12.2926 13.2788C12.5836 13.3367 12.8509 13.4796 13.0607 13.6893C13.2704 13.8991 13.4133 14.1664 13.4712 14.4574C13.5291 14.7483 13.4994 15.0499 13.3858 15.324C13.2723 15.5981 13.08 15.8324 12.8334 15.9972C12.5867 16.162 12.2967 16.25 12 16.25C11.6022 16.25 11.2206 16.092 10.9393 15.8107C10.658 15.5294 10.5 15.1478 10.5 14.75Z" fill="#3E4240" />
                        </g>
                        <defs>
                            <clipPath id="clip0_3_374">
                                <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
                            </clipPath>
                        </defs>
                    </svg>
                    } title={[PAYMENT_STATUS.FREE_COMPLETED, PAYMENT_STATUS.FREE_COMPLETED_V3].includes(paymentStatus) ? "14 days ago" : "Right now"} description={[PAYMENT_STATUS.FREE_COMPLETED, PAYMENT_STATUS.FREE_COMPLETED_V3].includes(paymentStatus) ? "You started full access to all the cool features" : "Get full access to TNT and watch your life transform like the northern lights. No cash needed yet"} active step={1} />
                    {/* <PlanStepInfo icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21.1209 15.5559C20.3072 14.1562 19.875 12.1472 19.875 9.75C19.875 7.66142 19.0453 5.65838 17.5685 4.18153C16.0916 2.70469 14.0886 1.875 12 1.875C9.91142 1.875 7.90838 2.70469 6.43153 4.18153C4.95468 5.65838 4.125 7.66142 4.125 9.75C4.125 12.1481 3.69468 14.1562 2.88093 15.5559C2.71488 15.8414 2.62687 16.1656 2.62571 16.4958C2.62456 16.8261 2.71032 17.1509 2.87437 17.4375C3.03739 17.7243 3.27399 17.9624 3.55977 18.1272C3.84554 18.292 4.17012 18.3775 4.5 18.375H7.89187C7.9849 19.4003 8.45794 20.3537 9.21808 21.048C9.97822 21.7423 10.9705 22.1273 12 22.1273C13.0295 22.1273 14.0218 21.7423 14.7819 21.048C15.542 20.3537 16.0151 19.4003 16.1081 18.375H19.5C19.8294 18.377 20.1534 18.2913 20.4386 18.1265C20.7239 17.9617 20.96 17.7239 21.1228 17.4375C21.2876 17.1513 21.3741 16.8267 21.3738 16.4965C21.3735 16.1662 21.2863 15.8418 21.1209 15.5559ZM12 19.875C11.5678 19.8751 11.1488 19.7258 10.8139 19.4525C10.4791 19.1791 10.2489 18.7985 10.1625 18.375H13.8375C13.751 18.7985 13.5209 19.1791 13.1861 19.4525C12.8512 19.7258 12.4322 19.8751 12 19.875ZM5.12437 16.125C5.95406 14.4375 6.375 12.2944 6.375 9.75C6.375 8.25816 6.96763 6.82742 8.02252 5.77252C9.07741 4.71763 10.5082 4.125 12 4.125C13.4918 4.125 14.9226 4.71763 15.9775 5.77252C17.0324 6.82742 17.625 8.25816 17.625 9.75C17.625 12.2934 18.045 14.4375 18.8747 16.125H5.12437Z" fill="#656565" />
                    </svg>
                    } title="Day 12" description="We’ll remind you with a notification that your trial ends soon" step={2} /> */}
                    <PlanStepInfo isMobile={isMobile} icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22.7813 9C22.665 8.64123 22.4449 8.32501 22.1489 8.09137C21.8528 7.85773 21.4941 7.71718 21.1181 7.6875L15.8128 7.25906L13.7653 2.30812C13.6214 1.95821 13.3768 1.65895 13.0625 1.44836C12.7482 1.23776 12.3783 1.12532 12 1.12532C11.6217 1.12532 11.2519 1.23776 10.9375 1.44836C10.6232 1.65895 10.3786 1.95821 10.2347 2.30812L8.18907 7.26L2.88376 7.6875C2.50709 7.71856 2.14801 7.86026 1.85163 8.0948C1.55526 8.32933 1.33482 8.64623 1.21801 9.00567C1.1012 9.36511 1.09324 9.75106 1.19512 10.115C1.297 10.479 1.50418 10.8047 1.79063 11.0512L5.83876 14.5425L4.60126 19.7644C4.511 20.1325 4.53235 20.5192 4.66259 20.8752C4.79283 21.2312 5.02608 21.5404 5.33261 21.7634C5.63915 21.9864 6.00512 22.1131 6.38392 22.1274C6.76272 22.1417 7.1372 22.043 7.45969 21.8437L12 19.0491L16.5403 21.8437C16.8627 22.0416 17.2366 22.1394 17.6146 22.1247C17.9926 22.11 18.3577 21.9835 18.6638 21.7611C18.9699 21.5388 19.2031 21.2307 19.3339 20.8757C19.4647 20.5208 19.4873 20.135 19.3988 19.7672L18.1613 14.5453L22.2094 11.0541C22.4975 10.8069 22.7057 10.4797 22.8076 10.114C22.9094 9.74824 22.9002 9.36051 22.7813 9ZM16.1747 13.2844C16.0186 13.4189 15.9025 13.5938 15.839 13.7899C15.7755 13.986 15.7671 14.1957 15.8147 14.3962L17.0231 19.5L12.5897 16.7737C12.4124 16.6646 12.2082 16.6068 12 16.6068C11.7918 16.6068 11.5876 16.6646 11.4103 16.7737L6.97688 19.5L8.18532 14.4C8.23292 14.1995 8.22451 13.9897 8.16103 13.7936C8.09754 13.5976 7.98141 13.4227 7.82532 13.2881L3.86251 9.86625L9.05626 9.44719C9.26294 9.43058 9.46101 9.35718 9.6286 9.23508C9.79619 9.11299 9.92678 8.94695 10.0059 8.75531L12 3.92719L13.9941 8.75531C14.0732 8.94695 14.2038 9.11299 14.3714 9.23508C14.539 9.35718 14.7371 9.43058 14.9438 9.44719L20.1375 9.86625L16.1747 13.2844Z" fill="#656565" />
                    </svg>
                    } title={[PAYMENT_STATUS.FREE_COMPLETED, PAYMENT_STATUS.FREE_COMPLETED_V3].includes(paymentStatus) ? "Today" : "Day 15"} description={[PAYMENT_STATUS.FREE_COMPLETED, PAYMENT_STATUS.FREE_COMPLETED_V3].includes(paymentStatus) ? "Time to unlock the fridge! Just add your credit card info, and we can get back to our delicious data exploration together" : "Time to join our polar research team! Just add your credit card details to keep exploring"} step={3} active={[PAYMENT_STATUS.FREE_COMPLETED, PAYMENT_STATUS.FREE_COMPLETED_V3].includes(paymentStatus)} />
                </Box>
            </Box>
        }
        return null
    }
    const planRender = () => {
        if ([PAYMENT_STATUS.FREE_COMPLETED, PAYMENT_STATUS.FREE_COMPLETED_V3, PAYMENT_STATUS.PAYMENT_FAILED].includes(paymentStatus)) {
            console.log("IUserTypeState.planProducts", IUserTypeState.planProducts);

            return <Box display={"flex"} flexDirection={"column"} gap={"8px"} padding={isMobile ? "0px 24px" : "0px 32px"} sx={{
                marginTop: [PAYMENT_STATUS.SUBSCRIPTION_ENDED, PAYMENT_STATUS.PAYMENT_FAILED].includes(paymentStatus) || isMobile ? "0px" : "24px",
                width: "100%",
                height: "auto"
            }}>
                {[PAYMENT_STATUS.SUBSCRIPTION_ENDED, PAYMENT_STATUS.PAYMENT_FAILED, PAYMENT_STATUS.FREE_COMPLETED_V3].includes(paymentStatus) && (
                    <CommonTypo size={16} fontWeight={700} lineHeight={24} color="var(--color-text-primary)">{"What’s your pass?"}</CommonTypo>
                )}
                <FormControl sx={true ? {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    alignSelf: 'stretch',
                    justifyContent: "center",
                    width: "100%",
                } : {
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '8px',
                    alignSelf: 'stretch',
                }}>
                    {<RadioGroup
                        className="radio-wrapper"
                        aria-labelledby="demo-radio-buttons-group-label"
                        name="radio-buttons-group"
                        onChange={(e) => setSelectedPlan(e.target.value)}
                        value={selectedPlan || ""}
                        sx={true ? {
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: '8px',
                            alignSelf: 'stretch',
                            padding: "0px",
                            width: "100%",
                            marginBottom: 0,
                            flexWrap: "wrap"
                        } : {
                            width: "100%",
                            marginBottom: 0
                        }}
                    >
                        {IUserTypeState.planProducts.map(({ name, price: { id, currency, unit_amount } }) => {
                            return <FormControlLabel value={id} control={<Radio sx={{
                                "&.MuiRadio-root.Mui-checked": {
                                    color: "var(--color-text-primary)"
                                },
                                "&.MuiRadio-root": {
                                    padding: "0px"
                                }
                            }} />} label={<Box display={"flex"} flexDirection={"column"} gap={"4px"}>
                                <Box display={"flex"} gap={"9px"} alignItems={"center"}>
                                    <CommonTypo size={isMobile ? 14 : 16} fontWeight={600} lineHeight={isMobile ? 16 : 19.2} color="var(--color-text-primary)">{name}</CommonTypo>
                                    {name === "Yearly" && (
                                        <Box display={"flex"} gap={"8px"} alignItems={"center"} height={"18px"} padding={"4px"} sx={{
                                            borderRadius: "6px",
                                            background: "var(--color-new-main)"
                                        }}>
                                            <CommonTypo size={10} fontWeight={600} lineHeight={10} color="var(--color-text-primary)">{"2 -month discount"}</CommonTypo>
                                        </Box>
                                    )}
                                </Box>
                                {name === "Yearly" && (
                                    <Box display={"flex"} gap={"4px"} alignItems={"center"}>
                                        <CommonTypo size={14} fontWeight={isMobile ? 400 : 500} lineHeight={22.4} color="var(--color-text-primary)">${unit_amount / 100}/year</CommonTypo>
                                        <CommonTypo size={14} fontWeight={400} lineHeight={22.4} color="var(--color-text-secondary)" extraSx={{
                                            textDecoration: "line-through"
                                        }}>$119.99/year</CommonTypo>
                                    </Box>
                                )}
                                {name === "Monthly" && (
                                    <Box display={"flex"} gap={"4px"} alignItems={"center"}>
                                        <CommonTypo size={14} fontWeight={isMobile ? 400 : 500} lineHeight={22.4} color="var(--color-text-primary)">${unit_amount / 100}/month</CommonTypo>
                                    </Box>
                                )}
                                {name === "Daily Plan" && (
                                    <Box display={"flex"} gap={"4px"} alignItems={"center"}>
                                        <CommonTypo size={14} fontWeight={isMobile ? 400 : 500} lineHeight={22.4} color="var(--color-text-primary)">${unit_amount / 100}/day</CommonTypo>
                                    </Box>
                                )}
                            </Box>} sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '16px',
                                width: "49%",
                                height: "78px",
                                border: "1px solid var(--color-border)",
                                borderRadius: '12px',
                                padding: "16px",
                                background: 'var(--white-background)',
                                marginRight: 0,
                                marginLeft: 0,
                                "& .MuiTypography-root": {
                                    color: "var(--color-text-primary) !important",
                                },
                                "@media (max-width: 786px)": {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '16px',
                                    width: "100%",
                                    height: "60px",
                                    alignSelf: "stretch",
                                    border: "1px solid var(--color-border)",
                                    borderRadius: '12px',
                                    padding: "8px 16px",
                                    background: 'var(--white-background)',
                                    marginRight: 0,
                                    marginLeft: 0,
                                    "& .MuiTypography-root": {
                                        color: "var(--color-text-primary) !important",
                                    },
                                },
                            }} />
                        })}


                    </RadioGroup>}
                </FormControl>
            </Box>
        }
        if ([PAYMENT_STATUS.PAYMENT_SUCCESS].includes(paymentStatus)) {
            const foundPlan = IUserTypeState.planProducts.find(it => it.name === IUserTypeState.userDetails.planName)
            let expiryDate = null
            if (IUserTypeState.userDetails?.paymentExpiry_date) {
                expiryDate = moment(IUserTypeState.userDetails?.paymentExpiry_date).format("DD MMM YYYY")
            }
            let price = null
            if (foundPlan) {
                const { unit_amount } = foundPlan.price
                price = unit_amount
            }
            return <Box display={"flex"} flexDirection={"column"} gap={"8px"} padding={"0px 32px"} sx={{
                marginTop: [PAYMENT_STATUS.PAYMENT_SUCCESS].includes(paymentStatus) ? "0px" : "24px",
                width: "100%",
            }}>
                {[PAYMENT_STATUS.PAYMENT_SUCCESS].includes(paymentStatus) && (
                    <CommonTypo size={16} fontWeight={700} lineHeight={24} color="var(--color-text-primary)">{"You purchased"}</CommonTypo>
                )}
                <Box width={"100%"} borderRadius={"12px"} border={"1px solid var(--color-border)"} padding={isMobile ? "8px 16px" : "16px"}>
                    <Box width={"100%"} display={"flex"} flexDirection={"column"} gap={"4px"}>
                        <CommonTypo size={isMobile ? 14 : 16} fontWeight={isMobile ? 600 : 700} lineHeight={isMobile ? 18 : 24} color="var(--color-text-primary)">{foundPlan?.name}</CommonTypo>
                        {foundPlan?.name === "Yearly" && (
                            <Box width={"100%"} display={"flex"} flexDirection={isMobile ? "column" : "row"} alignItems={isMobile ? "flex-start" : "center"} justifyContent={"space-between"} gap={"4px"}>
                                <CommonTypo size={14} fontWeight={500} lineHeight={isMobile ? 18 : 22.4} color="var(--color-text-primary)">${price / 100}{"/year"}</CommonTypo>
                                <CommonTypo size={14} fontWeight={400} lineHeight={isMobile ? 18 : 22.4} color="var(--color-text-primary)">Continues {expiryDate}</CommonTypo>
                            </Box>
                        )}
                        {foundPlan?.name === "Monthly" && (
                            <Box width={"100%"} display={"flex"} flexDirection={isMobile ? "column" : "row"} alignItems={isMobile ? "flex-start" : "center"} justifyContent={"space-between"} gap={"4px"}>
                                <CommonTypo size={14} fontWeight={500} lineHeight={isMobile ? 18 : 22.4} color="var(--color-text-primary)">${price / 100}{"/month"}</CommonTypo>
                                <CommonTypo size={14} fontWeight={400} lineHeight={isMobile ? 18 : 22.4} color="var(--color-text-primary)">Continues {expiryDate}</CommonTypo>
                            </Box>
                        )}
                        {foundPlan?.name === "Daily Plan" && (
                            <Box width={"100%"} display={"flex"} flexDirection={isMobile ? "column" : "row"} alignItems={isMobile ? "flex-start" : "center"} justifyContent={"space-between"} gap={"4px"}>
                                <CommonTypo size={14} fontWeight={500} lineHeight={isMobile ? 18 : 22.4} color="var(--color-text-primary)">${price / 100}{"/day"}</CommonTypo>
                                <CommonTypo size={14} fontWeight={400} lineHeight={isMobile ? 18 : 22.4} color="var(--color-text-secondary)">Continues {expiryDate}</CommonTypo>
                            </Box>
                        )}

                    </Box>
                </Box>
            </Box>
        }
        if ([PAYMENT_STATUS.FREE_COMPLETED_V2].includes(paymentStatus)) {
            return <><Box display={"flex"} flexDirection={"column"} gap={"8px"} padding={isMobile ? "0px 24px" : "0px 32px"} sx={{
                marginTop: "0px",
                width: "100%",
                height: "auto"
            }}>
                <Box display={"flex"} flexDirection={"column"} alignItems={isMobile ? "flex-start" : "center"} alignSelf={"stretch"} borderRadius={"12px"} gap={"8px"} border={"1px solid var(--color-border)"} padding={"16px"}>
                    <CommonTypo size={isMobile ? 12 : 16} fontWeight={400} lineHeight={16} color="var(--color-text-primary)">Time until your data will be deleted:</CommonTypo>
                    <CommonTypo size={isMobile ? 18 : 32} fontWeight={600} lineHeight={isMobile ? 20 : 36} color="var(--color-text-primary)"><AccountRestrictionTimeout showFullTime /></CommonTypo>

                </Box>
            </Box>
                <Box display={"flex"} flexDirection={"column"} gap={"8px"} padding={isMobile ? "0px 32px" : "0px 32px"} sx={{
                    marginTop: "0px",
                    width: "100%",
                    height: "auto"
                }}>
                    {[PAYMENT_STATUS.FREE_COMPLETED_V2, PAYMENT_STATUS.PAYMENT_FAILED].includes(paymentStatus) && (
                        <CommonTypo size={16} fontWeight={isMobile ? 600 : 400} lineHeight={isMobile ? 18 : 16} color="var(--color-text-primary)">{"Subscribe to save your progress and data"}</CommonTypo>
                    )}
                    <FormControl sx={true ? {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        alignSelf: 'stretch',
                        justifyContent: "center",
                        width: "100%",
                    } : {
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: '8px',
                        alignSelf: 'stretch',
                    }}>
                        {<RadioGroup
                            className="radio-wrapper"
                            aria-labelledby="demo-radio-buttons-group-label"
                            name="radio-buttons-group"
                            onChange={(e) => setSelectedPlan(e.target.value)}
                            value={selectedPlan || ""}
                            sx={true ? {
                                display: 'flex',
                                alignItems: 'flex-start',
                                gap: '8px',
                                alignSelf: 'stretch',
                                padding: "0px",
                                width: "100%",
                                marginBottom: 0,
                                flexWrap: "wrap"
                            } : {
                                width: "100%",
                                marginBottom: 0
                            }}
                        >
                            {IUserTypeState.planProducts.map(({ name, price: { id, currency, unit_amount } }) => {
                                return <FormControlLabel value={id} control={<Radio sx={{
                                    "&.MuiRadio-root.Mui-checked": {
                                        color: "var(--color-text-primary)"
                                    },
                                    "&.MuiRadio-root": {
                                        padding: "0px"
                                    }
                                }} />} label={<Box display={"flex"} flexDirection={"column"} gap={"4px"}>
                                    <Box display={"flex"} gap={"9px"} alignItems={"center"}>
                                        <CommonTypo size={isMobile ? 14 : 16} fontWeight={600} lineHeight={isMobile ? 16 : 19.2} color="var(--color-text-primary)">{name}</CommonTypo>
                                        {name === "Yearly" && (
                                            <Box display={"flex"} gap={"8px"} alignItems={"center"} height={"18px"} padding={"4px"} sx={{
                                                borderRadius: "6px",
                                                background: "var(--color-new-main)"
                                            }}>
                                                <CommonTypo size={10} fontWeight={600} lineHeight={10} color="var(--color-text-primary)">{"2 -month discount"}</CommonTypo>
                                            </Box>
                                        )}
                                    </Box>
                                    {name === "Yearly" && (
                                        <Box display={"flex"} gap={"4px"} alignItems={"center"}>
                                            <CommonTypo size={14} fontWeight={isMobile ? 400 : 500} lineHeight={22.4} color="var(--color-text-primary)">${unit_amount / 100}/year</CommonTypo>
                                            <CommonTypo size={14} fontWeight={400} lineHeight={22.4} color="var(--color-text-secondary)" extraSx={{
                                                textDecoration: "line-through"
                                            }}>$119.99/year</CommonTypo>
                                        </Box>
                                    )}
                                    {name === "Monthly" && (
                                        <Box display={"flex"} gap={"4px"} alignItems={"center"}>
                                            <CommonTypo size={14} fontWeight={isMobile ? 400 : 500} lineHeight={22.4} color="var(--color-text-primary)">${unit_amount / 100}/month</CommonTypo>
                                        </Box>
                                    )}
                                    {name === "Daily Plan" && (
                                        <Box display={"flex"} gap={"4px"} alignItems={"center"}>
                                            <CommonTypo size={14} fontWeight={isMobile ? 400 : 500} lineHeight={22.4} color="var(--color-text-primary)">${unit_amount / 100}/day</CommonTypo>
                                        </Box>
                                    )}
                                </Box>} sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '16px',
                                    width: "49%",
                                    height: "78px",
                                    border: "1px solid var(--color-border)",
                                    borderRadius: '12px',
                                    padding: "16px",
                                    background: 'var(--white-background)',
                                    marginRight: 0,
                                    marginLeft: 0,
                                    "& .MuiTypography-root": {
                                        color: "var(--color-text-primary) !important",
                                    },
                                    "@media (max-width: 786px)": {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '16px',
                                        width: "100%",
                                        height: "60px",
                                        alignSelf: "stretch",
                                        border: "1px solid var(--color-border)",
                                        borderRadius: '12px',
                                        padding: "8px 16px",
                                        background: 'var(--white-background)',
                                        marginRight: 0,
                                        marginLeft: 0,
                                        "& .MuiTypography-root": {
                                            color: "var(--color-text-primary) !important",
                                        },
                                    },
                                }} />
                            })}


                        </RadioGroup>}
                    </FormControl>
                </Box>
            </>
        }
        return null
    }
    const buttonsRender = () => {
        switch (paymentStatus) {

            case PAYMENT_STATUS.FREE_COMPLETED:
                return <Box display={"flex"} flexDirection={"column"} gap={isMobile ? "8px" : "24px"} padding={isMobile ? "0px 24px" : "0px 32px"} sx={{
                    marginTop: "0px",
                    width: "100%",
                    marginBottom: "32px"
                }}>
                    <Box display={"flex"} alignItems={"center"} justifyContent={"center"}>
                        <NewButton
                            type="button"
                            isDisabled={false}
                            boxSx={{
                                display: 'flex',
                                alignSelf: "stretch",
                                width: "312px",
                                justifyContent: "center",
                            }}
                            extraSx={{
                                display: 'flex',
                                alignSelf: "stretch",
                                width: isMobile ? "100%" : "312px",
                                background: "var(--color-new-main)",
                                height: "40px",
                                "&:hover": {
                                    background: "var(--color-new-main)",
                                }
                            }}
                            typographySx={{
                                "&.MuiTypography-root": {
                                    fontSize: `${pxToRem(16)} !important`,
                                    lineHeight: "100% !important",
                                    fontWeight: 600,
                                    color: "var(--color-text-primary)",
                                    "@media  (max-width: 786px) and (min-width: 100px)": {
                                        fontSize: `${pxToRem(16)} !important`,
                                        lineHeight: "100% !important",
                                        fontWeight: 600,
                                        color: "var(--color-text-primary)"
                                    },
                                },
                            }}
                            buttonText={<Box display={"flex"} alignItems={"center"} gap={"4px"}>
                                <CommonTypo color="var(--color-text-primary)" fontWeight={600} size={16} lineHeight={16}>Subscribe</CommonTypo>
                            </Box>}
                            onClick={closeWithSelectedPlan}
                            fontSize="18px"
                        // isLoadong={showLoader}
                        />
                    </Box>
                </Box>
            case PAYMENT_STATUS.FREE_COMPLETED_V2:
                return <Box display={"flex"} flexDirection={"column"} gap={isMobile ? "8px" : "24px"} padding={isMobile ? "0px 24px" : "0px 32px"} sx={{
                    marginTop: "0px",
                    width: "100%",
                    marginBottom: "32px"
                }}>
                    <Box display={"flex"} alignItems={"center"} justifyContent={"center"}>
                        <NewButton
                            type="button"
                            isDisabled={false}
                            boxSx={{
                                display: 'flex',
                                alignSelf: "stretch",
                                width: "312px",
                                justifyContent: "center",
                            }}
                            extraSx={{
                                display: 'flex',
                                alignSelf: "stretch",
                                width: isMobile ? "100%" : "312px",
                                background: "var(--color-new-main)",
                                height: "40px",
                                "&:hover": {
                                    background: "var(--color-new-main)",
                                }
                            }}
                            typographySx={{
                                "&.MuiTypography-root": {
                                    fontSize: `${pxToRem(16)} !important`,
                                    lineHeight: "100% !important",
                                    fontWeight: 600,
                                    color: "var(--color-text-primary)",
                                    "@media  (max-width: 786px) and (min-width: 100px)": {
                                        fontSize: `${pxToRem(16)} !important`,
                                        lineHeight: "100% !important",
                                        fontWeight: 600,
                                        color: "var(--color-text-primary)"
                                    },
                                },
                            }}
                            buttonText={<Box display={"flex"} alignItems={"center"} gap={"4px"}>
                                <CommonTypo color="var(--color-text-primary)" fontWeight={600} size={16} lineHeight={16}>Subscribe</CommonTypo>
                            </Box>}
                            onClick={closeWithSelectedPlan}
                            fontSize="18px"
                        // isLoadong={showLoader}
                        />
                    </Box>
                </Box>
            case PAYMENT_STATUS.SUBSCRIPTION_ENDED:
            case PAYMENT_STATUS.FREE_COMPLETED_V3:
                return <Box display={"flex"} flexDirection={"column"} gap={"8px"} padding={isMobile ? "0px 24px" : "0px 32px"} sx={{
                    marginTop: "0px",
                    width: "100%",
                    marginBottom: "32px"
                }}>
                    <Box display={"flex"} alignItems={"center"} justifyContent={"center"}>
                        <NewButton
                            type="button"
                            isDisabled={false}
                            boxSx={{
                                display: 'flex',
                                alignSelf: "stretch",
                                width: "312px",
                                justifyContent: "center",
                            }}
                            extraSx={{
                                display: 'flex',
                                alignSelf: "stretch",
                                width: isMobile ? "100%" : "312px",
                                background: "var(--color-new-main)",
                                height: "40px",
                                "&:hover": {
                                    background: "var(--color-new-main)",
                                }
                            }}
                            typographySx={{
                                "&.MuiTypography-root": {
                                    fontSize: `${pxToRem(16)} !important`,
                                    lineHeight: "100% !important",
                                    fontWeight: 600,
                                    color: "var(--color-text-primary)",
                                    "@media  (max-width: 786px) and (min-width: 100px)": {
                                        fontSize: `${pxToRem(16)} !important`,
                                        lineHeight: "100% !important",
                                        fontWeight: 600,
                                        color: "var(--color-text-primary)"
                                    },
                                },
                            }}
                            buttonText={<Box display={"flex"} alignItems={"center"} gap={"4px"}>
                                <CommonTypo color="var(--color-text-primary)" fontWeight={600} size={16} lineHeight={16}>Enter the club</CommonTypo>
                            </Box>}
                            onClick={paymentStatus === PAYMENT_STATUS.FREE_COMPLETED_V3 ? closeWithSelectedPlan : getBillingPorta}
                            fontSize="18px"
                        // isLoadong={showLoader}
                        />
                    </Box>
                </Box>
            case PAYMENT_STATUS.PAYMENT_SUCCESS:
                return <Box display={"flex"} flexDirection={"column"} gap={"8px"} padding={isMobile ? "0px 24px" : "0px 32px"} sx={{
                    marginTop: "0px",
                    width: "100%",
                    marginBottom: "32px"
                }}>
                    <Box display={"flex"} alignItems={"center"} justifyContent={"center"}>
                        <NewButton
                            type="button"
                            isDisabled={false}
                            boxSx={{
                                display: 'flex',
                                alignSelf: "stretch",
                                width: "312px",
                                justifyContent: "center",
                            }}
                            extraSx={{
                                display: 'flex',
                                alignSelf: "stretch",
                                width: isMobile ? "100%" : "312px",
                                background: "var(--color-new-main)",
                                height: "40px",
                                "&:hover": {
                                    background: "var(--color-new-main)",
                                }
                            }}
                            typographySx={{
                                "&.MuiTypography-root": {
                                    fontSize: `${pxToRem(16)} !important`,
                                    lineHeight: "100% !important",
                                    fontWeight: 600,
                                    color: "var(--color-text-primary)",
                                    "@media  (max-width: 786px) and (min-width: 100px)": {
                                        fontSize: `${pxToRem(16)} !important`,
                                        lineHeight: "100% !important",
                                        fontWeight: 600,
                                        color: "var(--color-text-primary)"
                                    },
                                },
                            }}
                            buttonText={<Box display={"flex"} alignItems={"center"} gap={"4px"}>
                                <CommonTypo color="var(--color-text-primary)" fontWeight={600} size={16} lineHeight={16}>Show me around</CommonTypo>
                            </Box>}
                            onClick={() => {
                                navigate("/tracking")
                                onClose()
                            }}
                            fontSize="18px"
                        // isLoadong={showLoader}
                        />
                    </Box>
                </Box>
            case PAYMENT_STATUS.PAYMENT_FAILED:
                return <Box display={"flex"} flexDirection={"column"} gap={"8px"} padding={isMobile ? "0px 24px" : "0px 32px"} sx={{
                    marginTop: isMobile ? "0px" : "24px",
                    width: "100%",
                    marginBottom: "32px"
                }}>
                    <Box display={"flex"} alignItems={"center"} justifyContent={"center"}>
                        <NewButton
                            type="button"
                            isDisabled={false}
                            boxSx={{
                                display: 'flex',
                                alignSelf: "stretch",
                                width: "312px",
                                justifyContent: "center",
                            }}
                            extraSx={{
                                display: 'flex',
                                alignSelf: "stretch",
                                width: isMobile ? "100%" : "312px",
                                background: "var(--color-new-main)",
                                height: "40px",
                                "&:hover": {
                                    background: "var(--color-new-main)",
                                }
                            }}
                            typographySx={{
                                "&.MuiTypography-root": {
                                    fontSize: `${pxToRem(16)} !important`,
                                    lineHeight: "100% !important",
                                    fontWeight: 600,
                                    color: "var(--color-text-primary)",
                                    "@media  (max-width: 786px) and (min-width: 100px)": {
                                        fontSize: `${pxToRem(16)} !important`,
                                        lineHeight: "100% !important",
                                        fontWeight: 600,
                                        color: "var(--color-text-primary)"
                                    },
                                },
                            }}
                            buttonText={<Box display={"flex"} alignItems={"center"} gap={"4px"}>
                                <CommonTypo color="var(--color-text-primary)" fontWeight={600} size={16} lineHeight={16}>Try again</CommonTypo>
                            </Box>}
                            onClick={closeWithSelectedPlan}
                            fontSize="18px"
                        // isLoadong={showLoader}
                        />
                    </Box>
                </Box>
            default:
                return <Box display={"flex"} flexDirection={"column"} gap={isMobile ? "8px" : "24px"} padding={isMobile ? "0px 24px" : "0px 32px"} sx={{
                    marginTop: "0px",
                    width: "100%",
                    marginBottom: "32px"
                }}>
                    <Box display={"flex"} alignItems={"center"} justifyContent={"center"}>
                        <NewButton
                            type="button"
                            isDisabled={false}
                            boxSx={{
                                display: 'flex',
                                alignSelf: "stretch",
                                width: "312px",
                                justifyContent: "center",
                            }}
                            extraSx={{
                                display: 'flex',
                                alignSelf: "stretch",
                                width: isMobile ? "100%" : "312px",
                                background: "var(--color-new-main)",
                                height: "40px",
                                "&:hover": {
                                    background: "var(--color-new-main)",
                                }
                            }}
                            typographySx={{
                                "&.MuiTypography-root": {
                                    fontSize: `${pxToRem(16)} !important`,
                                    lineHeight: "100% !important",
                                    fontWeight: 600,
                                    color: "var(--color-text-primary)",
                                    "@media  (max-width: 786px) and (min-width: 100px)": {
                                        fontSize: `${pxToRem(16)} !important`,
                                        lineHeight: "100% !important",
                                        fontWeight: 600,
                                        color: "var(--color-text-primary)"
                                    },
                                },
                            }}
                            buttonText={<Box display={"flex"} alignItems={"center"} gap={"4px"}>
                                <CommonTypo color="var(--color-text-primary)" fontWeight={600} size={16} lineHeight={16}>{"Awesome"}</CommonTypo>
                            </Box>}
                            onClick={onClose}
                            fontSize="18px"
                        // isLoadong={showLoader}
                        />
                    </Box>
                    <CommonTypo size={isMobile ? 12 : 16} lineHeight={isMobile ? 12 : 24} color="var(--color-text-secondary)" fontWeight={400} extraSx={{
                        textAlign: "center",
                        width: "100%"
                    }}>14 days free, then $9.99/month</CommonTypo>
                </Box>
        }
    }
    return <>
        <Dialog
            onClose={([PAYMENT_STATUS.FREE_COMPLETED_V2, PAYMENT_STATUS.FREE_COMPLETED_V3].includes(paymentStatus) && !isMobile) || ([PAYMENT_STATUS.FREE_COMPLETED_V3].includes(paymentStatus) && isMobile) ? closeWithRestrictions : () => { }}
            open={visiblePaymentInfo}
            className={"dialogWrapper"}
            disableEscapeKeyDown
            sx={{
                "& .MuiDialog-paper": {
                    display: 'flex !important',
                    padding: '0px',
                    flexDirection: 'column !important',
                    alignItems: 'flex-start !important',
                    gap: paymentStatus === PAYMENT_STATUS.FREE_COMPLETED_V2 && !isMobile ? "27px !important" : '24px !important',
                    width: "628px",
                    overflowY: "auto",
                    position: "relative",
                    "@media (max-width: 786px)": {
                        fontSize: `${pxToRem(16)} !important`,
                        width: "calc(100vw - 10%) !important",
                        padding: '0px !important',
                        borderRadius: "12px",
                        maxHeight: "calc(100vh - 20%)",
                        height: "max-content",
                    },
                    ...(isDarkMode ? {
                        backgroundColor: "var(--dark-background)",
                        backgroundImage: "none !important",
                        border: "1px solid var(--dark-border) !important",
                    } : {}),
                }
            }}
            PaperProps={{
                className: "hide-scrollbar"
            }}
        >
            {(subscriptionPlanEndedBilling || ([PAYMENT_STATUS.FREE_COMPLETED_V2, PAYMENT_STATUS.FREE_COMPLETED_V3].includes(paymentStatus) && !isMobile) || ([PAYMENT_STATUS.FREE_COMPLETED_V3].includes(paymentStatus) && isMobile)) && <IconButton
                onClick={([PAYMENT_STATUS.FREE_COMPLETED_V2, PAYMENT_STATUS.FREE_COMPLETED_V3].includes(paymentStatus) && !isMobile) || ([PAYMENT_STATUS.FREE_COMPLETED_V3].includes(paymentStatus) && isMobile) ? closeWithRestrictions : fixClosePopup}
                sx={{
                    position: "absolute",
                    right: "12px",
                    top: "10px",
                    padding: 0
                }}
            >
                <ModalCloseIconWhite size="24" />
            </IconButton>}
            <Box sx={{
                width: "100%",
                borderRadius: "12px 12px 0px 0px"
            }}>
                <img src={getImage()} alt="payment-logo" style={isMobile ? {
                    width: "100%",
                    height: "156px",
                    objectFit: "cover",
                    borderRadius: "12px 12px 0px 0px",
                    objectPosition: "center 75%"
                } : {
                    width: "100%",
                    height: "314px",
                    objectFit: "cover",
                    borderRadius: "12px 12px 0px 0px",
                    objectPosition: "center 75%"
                }} />
            </Box>
            {getTitleContent()}
            {getStepper()}
            {planRender()}
            {buttonsRender()}

        </Dialog>
        <SnackBarCompV2
            showSnakbar={showSnakbar}
            handleCloseSnakbar={() => {
                setShowSnakbar(false);
            }}

            snakbarMsg={<CommonTypo size={16} fontWeight={600} lineHeight={19.2} color="var(--color-text-primary)">{snakbarMsg}</CommonTypo>}
            type={msgType ? msgType : "success"}
            alertSx={{
                background: msgType === "error" ? "#FF5555" : "var(--color-new-main)",
                boxShadow: "0px 4px 8px 0px #0000001A",
                padding: "16px",
                borderRadius: "12px",
                height: "52px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                "& .MuiAlert-icon": {
                    marginRight: "0px"
                }
            }}
            icon={msgType === "success" ? <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.7883 7.46172C13.8757 7.54882 13.945 7.65231 13.9923 7.76626C14.0397 7.88022 14.064 8.00239 14.064 8.12578C14.064 8.24917 14.0397 8.37134 13.9923 8.4853C13.945 8.59925 13.8757 8.70275 13.7883 8.78984L9.41328 13.1648C9.32619 13.2522 9.22269 13.3216 9.10874 13.3689C8.99478 13.4162 8.87261 13.4406 8.74922 13.4406C8.62583 13.4406 8.50366 13.4162 8.3897 13.3689C8.27575 13.3216 8.17226 13.2522 8.08516 13.1648L6.21016 11.2898C6.12295 11.2026 6.05378 11.0991 6.00658 10.9852C5.95939 10.8712 5.9351 10.7491 5.9351 10.6258C5.9351 10.5025 5.95939 10.3803 6.00658 10.2664C6.05378 10.1525 6.12295 10.0489 6.21016 9.96172C6.29737 9.87451 6.40089 9.80534 6.51483 9.75814C6.62877 9.71095 6.75089 9.68666 6.87422 9.68666C6.99755 9.68666 7.11967 9.71095 7.23361 9.75814C7.34755 9.80534 7.45108 9.87451 7.53828 9.96172L8.75 11.1719L12.4617 7.45938C12.5489 7.37236 12.6525 7.3034 12.7664 7.25642C12.8803 7.20944 13.0023 7.18537 13.1255 7.18559C13.2487 7.18581 13.3706 7.21031 13.4844 7.25769C13.5981 7.30507 13.7014 7.3744 13.7883 7.46172ZM18.4375 10C18.4375 11.6688 17.9427 13.3001 17.0155 14.6876C16.0884 16.0752 14.7706 17.1566 13.2289 17.7952C11.6871 18.4338 9.99064 18.6009 8.35393 18.2754C6.71721 17.9498 5.2138 17.1462 4.03379 15.9662C2.85379 14.7862 2.05019 13.2828 1.72463 11.6461C1.39907 10.0094 1.56616 8.31286 2.20477 6.77111C2.84338 5.22936 3.92484 3.9116 5.31238 2.98448C6.69992 2.05735 8.33122 1.5625 10 1.5625C12.237 1.56498 14.3817 2.45473 15.9635 4.03653C17.5453 5.61833 18.435 7.763 18.4375 10ZM16.5625 10C16.5625 8.70206 16.1776 7.43327 15.4565 6.35407C14.7354 5.27487 13.7105 4.43374 12.5114 3.93704C11.3122 3.44034 9.99272 3.31038 8.71972 3.5636C7.44672 3.81681 6.2774 4.44183 5.35962 5.35961C4.44183 6.27739 3.81682 7.44672 3.5636 8.71972C3.31038 9.99272 3.44034 11.3122 3.93704 12.5114C4.43374 13.7105 5.27488 14.7354 6.35407 15.4565C7.43327 16.1776 8.70206 16.5625 10 16.5625C11.7399 16.5606 13.408 15.8686 14.6383 14.6383C15.8686 13.408 16.5606 11.7399 16.5625 10Z" fill="#3E4240" />
            </svg> : null
            }
        />
    </>

}

export default PaymentPlanInfo

const PlanStepInfo = ({
    icon = null,
    title = "",
    isMobile = false,
    description = "",
    active = false,
    step = 1
}) => {
    return <Box display={"flex"} gap={isMobile ? "16px" : "8px"} alignItems={"center"} >
        <Box display={"flex"} gap={"8px"} alignItems={"center"} justifyContent={"center"} sx={isMobile ? {
            position: "relative",
            "&:before": step === 1 ? {
                content: '""',
                display: "flex",
                position: "absolute",
                top: 0, // Adjust to properly align
                width: 8,
                height: 28,
                backgroundColor: active ? "var(--color-new-main)" : "var(--color-border)",
                transform: "translateY(-26px) rotate(0deg)",
                zIndex: 0,
                borderRadius: "8px"
            } : step === 2 ? {
                content: '""',
                display: "flex",
                position: "absolute",
                top: 0, // Adjust to properly align
                width: 8,
                height: 60,
                backgroundColor: active ? "var(--color-new-main)" : "var(--color-border)",
                transform: "translateY(-60px) rotate(0deg)",
                zIndex: 0,
                borderRadius: "8px"
            } : step === 3 ? {
                content: '""',
                display: "flex",
                position: "absolute",
                top: 0, // Adjust to properly align
                width: 8,
                height: 110,
                backgroundColor: active ? "var(--color-new-main)" : "var(--color-border)",
                transform: "translateY(-60px) rotate(0deg)",
                zIndex: 0,
                borderRadius: "8px"
            } : {},
            "&:after": step === 3 && active ? {
                content: '""',
                display: "flex",
                position: "absolute",
                top: 0, // Adjust to properly align
                width: 8,
                height: 20,
                backgroundColor: "var(--color-new-main)",
                transform: "translateY(40px) rotate(0deg)",
                zIndex: 0,
                borderRadius: "8px"
            } : {}
        } : {
            width: isMobile ? "32px" : "48px",
            height: isMobile ? "32px" : "48px",
            padding: "0px",
            gap: "8px",
            borderRadius: "100%",
            background: active ? "var(--color-new-main)" : "var(--color-border)",
            border: isMobile ? "2.67px solid var(--white-background)" : "4px solid var(--white-background)",
            position: "relative",
            "&:before": step === 1 ? {
                content: '""',
                display: "flex",
                position: "absolute",
                top: 0, // Adjust to properly align
                width: 8,
                height: 30,
                backgroundColor: active ? "var(--color-new-main)" : "var(--color-border)",
                transform: "translateY(-32px) rotate(0deg)",
                zIndex: 0,
                borderRadius: "8px"
            } : step === 2 ? {
                content: '""',
                display: "flex",
                position: "absolute",
                top: 0, // Adjust to properly align
                width: 8,
                height: 60,
                backgroundColor: active ? "var(--color-new-main)" : "var(--color-border)",
                transform: "translateY(-60px) rotate(0deg)",
                zIndex: 0,
                borderRadius: "8px"
            } : step === 3 ? {
                content: '""',
                display: "flex",
                position: "absolute",
                top: 0, // Adjust to properly align
                width: 8,
                height: 95,
                backgroundColor: active ? "var(--color-new-main)" : "var(--color-border)",
                transform: "translateY(-60px) rotate(0deg)",
                zIndex: 0,
                borderRadius: "8px"
            } : {},
            "&:after": step === 3 && active ? {
                content: '""',
                display: "flex",
                position: "absolute",
                top: 0, // Adjust to properly align
                width: 8,
                height: 30,
                backgroundColor: "var(--color-border)",
                transform: "translateY(40px) rotate(0deg)",
                zIndex: 0,
                borderRadius: "8px"
            } : {}
        }}>
            <Box display={"flex"} gap={"8px"} alignItems={"center"} justifyContent={"center"} sx={isMobile ? {
                width: "32px",
                minWidth: "32px",
                height: "32px",
                minHeight: "32px",
                padding: "5.33px",
                gap: "5.33px",
                borderRadius: "100%",
                background: active ? "var(--color-new-main)" : "var(--color-border)",
                border: "2.67px solid var(--white-background)",
                zIndex: 1
            } : {
                width: isMobile ? "32px" : "48px",
                height: isMobile ? "32px" : "48px",
                padding: isMobile ? "5.33px" : "8px",
                gap: isMobile ? "5.33px" : "8px",
                borderRadius: "100%",
                background: active ? "var(--color-new-main)" : "var(--color-border)",
                border: isMobile ? "2.67px solid var(--white-background)" : "4px solid var(--white-background)",
                zIndex: 1
            }}>
                {icon}
            </Box>
        </Box>
        <Box display={"flex"} flexDirection={"column"} gap={isMobile ? "8px" : "4px"}>
            <CommonTypo size={14} fontWeight={700} lineHeight={14} color="var(--color-text-primary)">{title}</CommonTypo>
            {description.split("{#}").map(it => <CommonTypo size={isMobile ? 12 : 14} fontWeight={400} lineHeight={isMobile ? 14 : 21} color="var(--color-text-secondary)" key={it.trim()}>{it.trim()}</CommonTypo>)}
        </Box>
    </Box>
}

export const PAYMENT_STATUS = {
    ONBOARD: "ONBOARD",
    FREE_COMPLETED: "FREE_COMPLETED",
    FREE_COMPLETED_V2: "FREE_COMPLETED_V2",
    FREE_COMPLETED_V3: "FREE_COMPLETED_V3",
    SUBSCRIPTION_ENDED: "SUBSCRIPTION_ENDED",
    PAYMENT_SUCCESS: "PAYMENT_SUCCESS",
    PAYMENT_FAILED: "PAYMENT_FAILED",
    ACCOUNT_BLOCKED: "ACCOUNT_BLOCKED"
}